import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/genresume_ai/actions-runner/_work/client-code/client-code/components/layouts/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/genresume_ai/actions-runner/_work/client-code/client-code/components/layouts/Navbar.jsx");
